// Angular
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { AppState } from '../../../../../core/reducers';
// Layout
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import { TranslateService } from '@ngx-translate/core';

// Services and Models
import {
  AuthService,
  currentUser,
  selectUsersActionLoading,
  User,
  UserLoaded,
  UserOnServerCreated,
} from '../../../../../core/auth';
import { CompanyModel } from 'src/app/core/management/_models/company.model';
import { UserService } from 'src/app/core/auth/_services/user.service';
import { OfficeModel } from 'src/app/core/management/_models/office.model';
import { selectErrorState } from 'src/app/core/auth/_selectors/user.selectors';
import { UserOnServerUpdated } from 'src/app/core/auth/_actions/user.actions';
import { SubheaderService } from '../../../../../core/_base/layout';
import { AuthServer } from '../../../../../core/enums';
import { filter } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserProfileCropperComponent } from '../user-profile-cropper/user-profile-cropper.component';
import { CommunicationsService } from '../../../../../core/timeline/_services';
import { each } from 'lodash-es';
import { ImageSettingService } from '../../../../../core/services/image-setting.service';
import { NavigationService } from '../../../../../core/services/navigation.service';

export function ConfirmedValidator(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

@Component({
  selector: 'kt-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss'],
})
export class UserEditComponent implements OnInit, OnDestroy {
  // Public properties
  user: User;
  AuthServer = AuthServer;
  oldUser: User;
  selectedTab = 0;
  loading$: Observable<boolean>;
  rolesSubject = new BehaviorSubject<number[]>([]);
  newUser: any = {};
  userForm: FormGroup;
  hasFormErrors = false;
  hasSubmissionErrors = false;
  submissionErrorObj: any;
  hide: any;
  private subscriptions: Subscription[] = [];
  offices: OfficeModel[];
  filteredOptions: Observable<string[]>;
  companies: CompanyModel[];
  currentUserRoleType;
  currentUserCompany;
  formnotloaded = true;
  formcreated = false;
  withPhoto = false;
  file = [];
  attachments: string[] = [];
  files = [];
  @ViewChild('fileInput') fileInput: ElementRef;
  pathUserId: any;
  loggedInUser: any;
  currentUserId;
  disableBtn: boolean;
  companyId: any;
  imageChangedEvent: any = '';
  photoURL = '/assets/media/users/blank.jpg';
  data = [];
  role = null;
  updating = false;
  currentUser: User;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userFB: FormBuilder,
    private auth: AuthService,
    private userService: UserService,
    private translate: TranslateService,
    private layoutUtilsService: LayoutUtilsService,
    private authService: AuthService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    public subheaderService: SubheaderService,
    private dialog: MatDialog,
    private communicationsService: CommunicationsService,
    private imageSettingService: ImageSettingService,
    private navigationService: NavigationService,
  ) {
    this.store
      .pipe(
        select(currentUser),
        filter((res) => !!res.id),
      )
      .subscribe((res) => {
        this.currentUser = res;
        this.companyId = res.companyID;
      });
    this.activatedRoute.params.subscribe((params) => {
      this.pathUserId = params.id;
    });
    this.currentUserRoleType = this.currentUser.userType;
    this.currentUserId = this.auth.currentUserId;
    // tslint:disable-next-line:triple-equals
    if (this.currentUserId == this.pathUserId) {
      this.subheaderService.setBreadcrumbs([
        {
          title: 'My Profile',
          page: '/user-management/users/edit/' + this.pathUserId,
        },
      ]);
    } else {
      this.subheaderService.appendBreadcrumbs([
        {
          title: 'User Profile',
          page: '/user-management/users/edit/' + this.pathUserId,
        },
      ]);
    }
  }

  ngOnInit() {
    this.formcreated = false;
    this.newUser.userName = 'New';
    this.newUser.profileUrl = '';
    this.store.pipe(select(currentUser)).subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl('/');
      }
      this.loggedInUser = res !== undefined ? res : {};
    });
    this.userService.getAllCompanies().subscribe((res) => {
      this.companies = res;
    });
    if (this.currentUser.userType !== 'Super Admin') {
      this.userService.getAllOffices().subscribe((res) => {
        this.offices = res;
      });
    }
    this.loading$ = this.store.pipe(select(selectUsersActionLoading));
    const routeSubscription = this.activatedRoute.params.subscribe((params) => {
      const id = params.id;
      this.formnotloaded = true;
      this.pathUserId = id;
      if (id && id > 0) {
        this.authService.getQRVEYMenu(id, 'USER').subscribe((res) => {
          this.data = res?.data[0]?.apps;
          this.role = res?.data[0]?.role ? res.data[0].role : null;
          this.cdr.detectChanges();
        });
        this.userService.getUserById(id).subscribe((res) => {
          if (res === undefined) {
            this.goBack();
          } else if (res) {
            this.user = res;
            this.rolesSubject.next(this.user.roles);
            this.oldUser = Object.assign({}, this.user);

            this.initUser();
          }

          this.cdr.detectChanges();
        });
      } else {
        this.loading$ = of(false);
        this.user = new User();
        this.user.clear();
        this.rolesSubject.next(this.user.roles);
        this.oldUser = Object.assign({}, this.user);

        this.initUser();
      }
    });
    this.subscriptions.push(routeSubscription);
    this.currentUserId = this.auth.currentUserId;
    this.currentUserCompany = this.currentUser.companyID;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  /**
   * Init user
   */
  initUser() {
    this.createForm();
  }

  /**
   * Create form
   */
  createForm() {
    this.formnotloaded = false;
    const initialCompanyId = this.companies && this.companies.length > 0 ? this.companies[0].id : 0;
    let companyId =
      this.currentUser.userType !== 'Super Admin' && this.user.id !== 0
        ? this.user.companyID
        : initialCompanyId;
    if (this.currentUser.userType !== 'SuperAdmin') {
      companyId = this.currentUser.companyID ? this.currentUser.companyID : this.companyId;
    } else if (this.user.id !== 0) {
      companyId = this.user.companyID;
    } else {
      companyId = this.companies[0].id;
    }

    this.userForm = this.userFB.group(
      {
        username: [],
        password: [],
        email: [],
        stock: [this.user.userName, Validators.required],
        firstName: [this.user.firstName, Validators.required],
        lastName: [this.user.lastName, Validators.required],
        userEmail: [this.user.email, Validators.compose([Validators.required, Validators.email])],
        pass: [this.user.password],
        company: [companyId],
        primaryOffice: [this.user[`primaryOfficeiD`]],
        allowedOffices: [this.user.allowedOffices],
        isActive: [true, Validators.compose([Validators.required])],
        isAgent: [this.user.agent],
        confirmPassword: [this.user.confirmPassword, this.user.id ? null : Validators.required],
      },
      {
        validator: ConfirmedValidator('pass', 'confirmPassword'),
      },
    );
    if (this.currentUser.userType !== 'Super Admin') {
      this.userForm.get('primaryOffice').setValidators([Validators.required]);
    }
    if (this.user.id === 0 || this.user.id === undefined) {
      this.userForm
        .get('pass')
        .setValidators([
          Validators.required,
          Validators.pattern(
            /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@!%*?&#^])[A-Za-z\d$@!%*?&#^]{8,}/,
          ),
        ]);

      if (this.currentUser.userType === 'Super Admin') {
        this.userForm.get('company').setValidators([Validators.required]);
      }
    }
    this.formcreated = true;
    if (this.user?.profileUrl) {
      this.photoURL = this.user.profileUrl;
      this.cdr.detectChanges();
    }
  }

  get f() {
    return this.userForm.controls;
  }

  goBack() {
    this.navigationService.goBack();
  }

  reset() {
    const _title = this.translate.instant('DIALOG.RESET');
    const _description = this.translate.instant('DIALOG.ARE_YOU_SURE');
    const _waitDesciption = this.translate.instant('DIALOG.RESETING');

    const dialogRef = this.layoutUtilsService.confirmAction(_title, _description, _waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }

      this.user = Object.assign({}, this.oldUser);
      this.createForm();
      this.hasFormErrors = false;
      this.userForm.markAsPristine();
      this.userForm.markAsUntouched();
      this.userForm.updateValueAndValidity();
    });
  }

  onSumbit() {
    this.hasFormErrors = false;
    const controls = this.userForm.controls;
    /** check form */
    if (this.userForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());

      this.hasFormErrors = true;
      this.selectedTab = 0;
      return;
    }

    const editedUser = this.prepareUser();
    if (editedUser.id > 0) {
      this.updateUser(editedUser);
      return;
    }

    this.addUser(editedUser);
  }

  prepareUser(): User {
    const controls = this.userForm.controls;
    const _user = new User();
    _user.clear();
    _user.roles = this.rolesSubject.value;
    _user.id = this.user.id;
    _user.userName = controls.stock.value;
    _user.firstName = controls.firstName.value;
    _user.lastName = controls.lastName.value;
    _user.email = controls.userEmail.value;
    _user.isActive = controls.isActive.value;
    _user.agent = controls.isAgent.value;
    _user.companyID = controls.company.value;
    _user.primaryOffice = controls.primaryOffice.value;
    // tslint:disable-next-line:max-line-length
    _user.allowedOffices =
      controls.allowedOffices.value === null || controls.allowedOffices.value === undefined
        ? []
        : controls.allowedOffices.value;
    _user.password = controls.pass.value;
    _user.confirmPassword = controls.confirmPassword.value;
    if (this.withPhoto) {
      _user.addProfile = true;
    }
    for (const [key, value] of Object.entries(_user)) {
      if (typeof value === 'string') {
        _user[key] = value.trim();
      }
    }
    return _user;
  }

  /**
   * Add User
   *
   * @param _user
   */
  addUser(_user: User) {
    if (_user.addProfile) {
      this.store.dispatch(new UserOnServerCreated({ user: _user, file: this.files }));
    } else {
      this.store.dispatch(new UserOnServerCreated({ user: _user }));
    }
    const addSubscription = this.store.pipe(select(selectUsersActionLoading)).subscribe((res) => {
      if (res !== true) {
        this.store.pipe(select(selectErrorState)).subscribe((error) => {
          if (error && error.error) {
            if (error.error.errors) {
              this.submissionErrorObj = error.error.errors;
            } else {
              this.submissionErrorObj = [{ message: 'GLOBAL.UNSPECIFIED_ERROR' }];
            }
            this.hasSubmissionErrors = true;
          } else {
            const message = this.translate.instant('USER.ADDED');
            this.layoutUtilsService.showActionNotification(
              message,
              MessageType.Update,
              5000,
              false,
              false,
            );
            this.goBack();
          }
          this.cdr.detectChanges();
        });
      }
      this.cdr.detectChanges();
    });
    this.subscriptions.push(addSubscription);
  }

  /**
   * Update user
   *
   * @param _user
   */
  updateUser(_user: User) {
    const updatedUser: Update<User> = {
      id: _user.id,
      changes: _user,
    };
    this.store.dispatch(
      new UserOnServerUpdated({
        partialUser: updatedUser,
        user: _user,
      }),
    );
    const updateSubscription = this.store
      .pipe(select(selectUsersActionLoading))
      .subscribe((res) => {
        if (res !== true) {
          this.store.pipe(select(selectErrorState)).subscribe((error) => {
            if (error) {
              if (error.error.errors) {
                this.submissionErrorObj = error.error.errors;
              } else {
                this.submissionErrorObj = [{ message: 'GLOBAL.UNSPECIFIED_ERROR' }];
              }
              this.hasSubmissionErrors = true;
            } else {
              const message = this.translate.instant('USER.UPDATED');
              this.layoutUtilsService.showActionNotification(
                message,
                MessageType.Update,
                5000,
                false,
                false,
              );
              this.goBack();
            }
          });
        }
        this.cdr.detectChanges();
      });
    this.subscriptions.push(updateSubscription);
  }

  /**
   * Returns component title
   */
  getComponentTitle() {
    let result = 'Create ';
    if (!this.user || !this.user.id) {
      return result;
    }

    result = `${this.user.userName}`;
    return result;
  }

  /**
   * Close Alert
   *
   * @param $event: Event
   */
  onAlertClose() {
    this.hasFormErrors = false;
    this.hasSubmissionErrors = false;
  }

  /**
   * Checking control validation
   *
   * @param controlName: string => Equals to formControlName
   * @param validationType: string => Equals to valitors name
   */
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.userForm.controls[controlName];
    if (!control) {
      return false;
    }
    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  getStatusString(): string {
    switch (this.userForm.get('isActive').value) {
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
    }
    return '';
  }

  profileSelectedSuccess(value: any) {
    this.withPhoto = true;
    this.file = value;
  }

  authAccount(hostServer) {
    this.disableBtn = true;
    this.userService.getOAuthURL(hostServer).subscribe((res) => {
      this.user.inboxActivated = !this.user.inboxActivated;
      window.location.href = res.auth_uri;
      this.disableBtn = false;
    });
  }

  disconnectAccount() {
    this.disableBtn = true;
    this.userService.disconnectFromAuthServer().subscribe(() => {
      this.disableBtn = false;
      this.user.inboxActivated = !this.user.inboxActivated;
      this.cdr.detectChanges();
    });
  }

  getText(textType: boolean, hostServer: AuthServer) {
    const text = {
      [AuthServer.GOOGLE]: 'Google',
      [AuthServer.MICROSOFT]: 'Microsoft',
    };
    if (textType === false) {
      return 'Connect with ' + text[hostServer];
    }
    return 'Disconnect Account '; // + text[hostServer]
  }

  sendFiles(uuids) {
    const request = {
      id: this.user.id,
      updateProfile: false,
      profilePath: uuids,
      email: this.user.email,
      userName: this.user.userName,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
    };
    this.userService.changeProfilePic(request).subscribe((res) => {
      if (res.code === 200) {
        this.auth.getUserById(this.user.id).subscribe((userResult) => {
          if (userResult.profileUrl) {
            this.photoURL = userResult.profileUrl;
            const photo = document.getElementById('user_profile') as HTMLImageElement;
            if (userResult.profileUrl && photo) {
              photo.src = this.photoURL;
              if (this.currentUserId === userResult.id) {
                this.auth.getUserByToken().subscribe((user) => {
                  this.store.dispatch(new UserLoaded({ user }));
                  this.cdr.detectChanges();
                });
              }
              this.cdr.detectChanges();
              this.layoutUtilsService.showActionNotification(
                'Profile photo updated successfully',
                MessageType.Update,
                3000,
                false,
                false,
              );
            }
          }
        });
      } else {
        this.layoutUtilsService.showActionNotification(
          this.translate.instant('GLOBAL.UNSPECIFIED_ERROR'),
          MessageType.Update,
          3000,
          false,
          false,
        );
      }
    });
  }

  removeProfilePicture() {
    const request = {
      id: this.user.id,
      deleteProfile: true,
      email: this.user.email,
      userName: this.user.userName,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
    };
    this.userService.changeProfilePic(request).subscribe((res) => {
      if (res.code === 200) {
        this.auth.getUserById(this.user.id).subscribe((user) => {
          if (user.profileUrl === '') {
            this.photoURL = '/assets/media/users/blank.jpg';
            this.cdr.detectChanges();
            if (this.currentUserId === this.user.id) {
              this.auth.getUserByToken().subscribe((userRes) => {
                this.store.dispatch(new UserLoaded({ user: userRes }));
                this.cdr.detectChanges();
              });
            }
            this.layoutUtilsService.showActionNotification(
              'Profile photo Removed successfully',
              MessageType.Update,
              3000,
              false,
              false,
            );
          }
        });
      } else {
        this.layoutUtilsService.showActionNotification(
          this.translate.instant('GLOBAL.UNSPECIFIED_ERROR'),
          MessageType.Update,
          3000,
          false,
          false,
        );
      }
    });
  }

  updateProfilePicture() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '600px';
    dialogConfig.height = '400px';
    if (!this.user.id) {
      dialogConfig.data = { existImage: null, mode: 'UPDATE' };
      this.opendialog(dialogConfig);
    } else {
      this.userService.getUserById(this.user.id).subscribe((res) => {
        dialogConfig.data = { existImage: res.profileUrl, mode: 'UPDATE' };
        this.opendialog(dialogConfig);
      });
    }
  }
  opendialog(dialogConfig) {
    const dialogRef = this.dialog.open(UserProfileCropperComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.files = result.files;
        switch (result.mode) {
          case 'DELETE': {
            this.removeProfilePicture();
            break;
          }
          case 'UPDATE': {
            if (result.img) {
              const file = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
              if (this.user.id <= 0) {
                this.withPhoto = true;
                const photo = document.getElementById('user_profile') as HTMLImageElement;
                if (photo) {
                  this.photoURL = result.img;
                  result.files[0] = file;
                  this.cdr.detectChanges();
                }
                return;
              }
              const request = {
                id: this.user.id,
                updateProfile: true,
                email: this.user.email,
                userName: this.user.userName,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
              };
              this.userService.changeProfilePic(request).subscribe((profileResult) => {
                if (profileResult.profileUrl) {
                  const uuids = profileResult.uuid;
                  const profileUrl = profileResult.profileUrl;
                  this.communicationsService.uploadProfilePic(profileUrl, file).subscribe();
                  this.sendFiles(uuids);
                }
              });
            }
            break;
          }
        }
      }
    });
  }

  getBackURL(event: Event): void {
    event.stopPropagation();

    let backURL = localStorage.getItem('backURL');

    // tslint:disable-next-line:max-line-length
    backURL =
      backURL.includes('/user-management/users/edit') ||
      backURL.includes('/user-management/users/add')
        ? '/user-management/users'
        : backURL;

    localStorage.removeItem('backURL');
    this.router.navigateByUrl(backURL);
  }

  isSelectedChanged($event, app, mainApp = null) {
    if (app.pages && app.pages.length > 0 && !app.isSelected) {
      each(app.pages, (item) => (item.isSelected = true));
      app.isSelected = !app.isSelected;
      return;
    }

    if (app.pages && app.pages.length > 0 && app.isSelected) {
      each(app.pages, (item) => {
        item.isSelected = false;
      });
      app.isSelected = !app.isSelected;
      return;
    }
    if (!app.pages && app.isSelected) {
      mainApp.isSelected = true;
      return;
    }
  }

  updateAnalytics() {
    this.updating = true;
    if (!this.role) {
      return;
    }
    const _app = JSON.parse(JSON.stringify(this.data.filter((term) => term.isSelected)));
    each(_app, (p) => {
      p.pages = p.pages.filter((term) => term.isSelected);
    });
    const body = {
      role: this.role,
      user_type: 'USER',
      knostos_id: this.user.id,
      apps: _app,
    };
    this.authService.createUserAccess(body, this.user.id).subscribe(() => {
      this.updating = false;
      this.layoutUtilsService.showActionNotification(
        'Analytics Successfully Updated',
        MessageType.Read,
        3000,
        false,
        false,
      );
      this.cdr.detectChanges();
    });
  }

  setDefult(page, mainApp) {
    const res = page.is_default;
    mainApp.pages = mainApp.pages.map((term) => {
      term.is_default = false;
      return term;
    });
    page.is_default = !res;
    if (!page.isSelected) {
      page.isSelected = !page.isSelected;
    }
    if (page.isSelected) {
      mainApp.isSelected = true;
      return;
    }
  }
}
